import {FC, useMemo} from "react";
import {Modal, Spin} from "antd";
import {PresentationModalProps} from "./types";
import PresentationItemForm from "./presentation-form/PresentationItemForm";

const PresentationModal: FC<PresentationModalProps> = (props) => {
  const {presentationController} = props
  const {
    togglePresentationModal,
    isPresentationModalOpen,
    isLoading,
    form,
    selectedPresentationItem
  } = presentationController

  const title = useMemo(() => {
    return selectedPresentationItem ? "Редагувати запис" : "Додати запис"
  }, [selectedPresentationItem])
  
  return <Modal width={800} style={{top: 20}} title={title} open={isPresentationModalOpen} onOk={() => {
    form.submit()
  }}
                onCancel={togglePresentationModal}
                cancelButtonProps={{title: "Закрити"}} okButtonProps={{children: "Зберегти"}}>
    <Spin spinning={isLoading}>
      <PresentationItemForm presentationController={presentationController}/>
    </Spin>
  </Modal>
}

export default PresentationModal